import { number } from 'prop-types'
import { useIntl } from 'react-intl'
import ErrorTemplate from '../../organisms/error-template/error-template'

const ErrorPageComponent = (statusCode) => {
	const { formatMessage } = useIntl()

	return (
		<ErrorTemplate
			title={statusCode}
			message={formatMessage({ id: 'an_error_occurred', defaultMessage: 'An error occurred. Please try again later' })}
		/>
	)
}

ErrorPageComponent.propTypes = {
	/**
	 * Error status code
	 */
	statusCode: number,
}

export default ErrorPageComponent
